<template>
  <div class="agenda">
    <img src="https://p1.ssl.qhimg.com/t110b9a9301ef637c2bc789d69d.png" alt="" class="agendaBg" />
    <div class="agendaTitle">大会日程</div>
    <div class="agendaEn">CONFERENCE AGENDA</div>
    <van-tabs
      class="dateTab"
      title-active-color="#242933"
      title-inactive-color="#8A9099"
      color="#242933"
      background="#f3f3f3"
      :active="activeDate"
      @change="handleClickTab"
    >
      <van-tab color="#497CED" v-for="(item, index) in arr" :key="item.date">
        <template #title>
          <img
            v-if="index === activeDate"
            src="https://p1.ssl.qhimg.com/t110b9a9301fac23e609d1d9d72.png"
            alt=""
            class="dateTabLogo"
          />
          {{ item.date }}
        </template>
        <div class="agendaBox">
          <div class="agendaBoxTop">
            <div class="agendaBoxTopTitle">{{ item.title }}</div>
            <div class="agendaBoxTopTime">{{ item.time }}</div>
          </div>

          <van-tabs class="infoTab" :active="activeInfo">
            <van-tab v-for="(node, index) in item.info" :title="node.title">
              <div class="content">
                <div v-for="(element, index) in node.children" class="contentBox">
                  <div v-if="index + 1 !== node.children.length" class="contentBoxLine"></div>
                  <!-- {{ element }} -->
                  <div class="contentBoxTop">
                    <img
                      src="https://p0.ssl.qhimg.com/t11b673bcd63f2769f075005029.png"
                      alt=""
                      class="contentBoxTopImg"
                    />
                    <div class="contentBoxTopTime">{{ element.time }}</div>
                  </div>
                  <div v-for="(child, index) in element.detail" :key="index" class="contentBoxInfo">
                    <div class="contentBoxInfoLeft">
                      <div class="contentBoxInfoLeftTitle">{{ child.title }}</div>
                      <div class="contentBoxInfoLeftPlace">{{ child.place }}</div>
                    </div>
                    <div v-if="child.path" @click="jumpLink(child.path)" class="contentBoxInfoRight">
                      <img
                        src="https://p2.ssl.qhimg.com/t110b9a9301eee6c52ff02c0e5a.png"
                        alt=""
                        class="contentBoxInfoRightImg"
                      />
                      <span class="contentBoxInfoRightDetail">查看详情</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const activeDate = ref(0)
const activeInfo = ref(0)
const props = defineProps(['arr'])
const arr = props.arr || {}

const jumpLink = (url) => {
  if(url) {
    window.open(url, '_blank');
  }
}

const handleClickTab = (index) => {
  activeDate.value = index
}
</script>

<style lang="scss" scoped>
.agenda {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 20px;
  }
  &Bg {
    width: 60px;
    position: absolute;
    top: 145px;
    left: 0;
  }
}
.dateTab {
  &Logo {
    width: 24px;
  }
}
.content {
  margin-top: 20px;
}
.agendaBox {
  margin-top: 24px;
  border-radius: 16px;
  background-color: #fff;
  // opacity: 1;
  // background: rgba(255, 255, 255, 0.8);
  // backdrop-filter: blur(120px);
  padding: 16px 12px 20px;
  &Top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    &Title {
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
    }
    &Date {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 32px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-7 */
      color: #8a9099;
    }
  }
}
.infoTab {
  :deep(.van-tab--active) {
    color: #497ced;
  }
}
.content {
  margin-top: 20px;
  &Box {
    // background-color: pink;
    padding-bottom: 12px;
    &Line {
      position: absolute;
      height: 90%;
      top: 18px;
      left: 3px;
      width: 1px;
      background-color: #e8eaed;
    }
    &Top {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      &Img {
        width: 7px;
        height: 7px;
        margin-right: 8px;
      }
      &Time {
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        display: flex;
        align-items: center;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-8 */
        color: #525966;
      }
    }
    &Info {
      margin-left: 16px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      &Left {
        &Title {
          max-width: 240px;
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 500;
          line-height: 28px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          color: #3d3d3d;
        }
        &Place {
          font-family: Source Han Sans;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          /* Gray 中性/gray-7 */
          color: #8a9099;
        }
      }
      &Right {
        display: flex;
        align-items: center;
        &Img {
          width: 16px;
          margin-right: 4px;
        }
        &Detail {
          font-family: Source Han Sans;
          font-size: 12px;
          font-weight: normal;
          line-height: 20px;
          letter-spacing: 0.02em;
          font-variation-settings: 'opsz' auto;
          color: #497ced;
        }
      }
    }
  }
  &Box:last-child {
    margin-bottom: 0;
    border: none;
  }
}
</style>
